import BetInterface from 'app/interfaces/BetInterface';

export const mainLine = (bet: BetInterface): BetInterface => {
    if (bet.parent_bet) {
        return mainLine(bet.parent_bet);
    }

    return bet;
};
